import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapRetrieve } from '../common/rest.operators';
import {
    Definition,
    DefinitionTransformer,
    View,
} from '../insight/config.insight.model';
import { VisualItemInsightComponent } from '../insight/visual-item.insight.component';
import { LayoutQuery } from '../insight/visual-item.insight.model';

@Component({
    selector: '[cmpsInsightExplorerViewViewer]',
    templateUrl: './view-viewer.ie.component.html',
})
export class ViewViewerInsightExplorerComponent implements OnInit {
    @ViewChildren(VisualItemInsightComponent)
    items: QueryList<VisualItemInsightComponent>;

    def: Definition;
    view: View;
    layoutQuery: LayoutQuery;
    private readonly _nextVil: Subject<string>;
    private _nextVilSub: Subscription;
    vilsStr: string;

    constructor(
        private readonly _changeDetectorRef: ChangeDetectorRef,
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        this._nextVil = new Subject();
    }

    ngOnInit(): void {
        this._http
            .get(`${this._appConfig.API_ENDPOINTS.INSIGHT}/definition/default`)
            .pipe(
                mapRetrieve(new DefinitionTransformer()),
                catchError(() => of({} as any as Definition)),
                // eslint-disable-next-line no-return-assign
                tap((ret) => (this.def = ret)),
                tap(() => {
                    this._nextVilSub = this._nextVil
                        .asObservable()
                        .pipe(
                            debounceTime(1000),
                            tap((value) => {
                                this.layoutQuery.vils = JSON.parse(value);
                                this.layoutQuery.style();
                            }),
                        )
                        .subscribe();
                    this.onViewChange(this.def.views[0].viewIdentifier);
                }),
            )
            .subscribe();
    }

    onViewChange($event: string): void {
        this.view = this.def.views.find((e) => e.viewIdentifier === $event);
        if (this.layoutQuery) {
            this.layoutQuery.unbind();
        }
        this.layoutQuery = new LayoutQuery();
        this.layoutQuery.bind(this.view as any, () => {
            this.items.forEach((e) => e._layoutRows());
            this._changeDetectorRef.detectChanges();
        });
        this.layoutQuery.style();
        this.vilsStr = JSON.stringify(this.layoutQuery.vils, null, 2);
    }

    onTextChange($event): void {
        this._nextVil.next($event.target.value);
    }
}
